import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FeatureFlagQuery } from './state/feature-flag.query';
import { map } from 'rxjs';
import { RoutesManager } from '../shared/models/routes.interfaces';

export const DevFeatureFlagGuard: CanActivateFn = (route, state) => {
  const featureFlag = route.data.featureFlag;
  const featureFlagQuery = inject(FeatureFlagQuery);
  const router = inject(Router);
  
  return featureFlagQuery.selectFlag(featureFlag).pipe(
    map(isOn => isOn ? true : router.parseUrl(`/${RoutesManager.pageNotFound}`))
  );
};
